import { render, staticRenderFns } from "./StatReadingDetail.vue?vue&type=template&id=40ff2e92&scoped=true&"
import script from "./StatReadingDetail.vue?vue&type=script&lang=js&"
export * from "./StatReadingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff2e92",
  null
  
)

export default component.exports